import { render, staticRenderFns } from "./SectionHead.vue?vue&type=template&id=48ff1505&scoped=true&"
import script from "./SectionHead.vue?vue&type=script&lang=js&"
export * from "./SectionHead.vue?vue&type=script&lang=js&"
import style0 from "./SectionHead.vue?vue&type=style&index=0&id=48ff1505&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ff1505",
  null
  
)

export default component.exports